import {
  Component,
  ElementRef,
  Input,
  OnInit,
  Renderer2,
  ViewChild,
  ChangeDetectorRef,
  HostListener,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
} from '@angular/core';

import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from '../../../services/auth-service.service';
import { SharedService } from '../../../services/shared.service';

import { ChatbotService } from './chatbot.service';
import { environment } from '../../../../../environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ImageModalComponent } from './image-modal.component';
import { HttpEventType } from '@angular/common/http';
import { ReportChatMessageModalComponent } from './report-modal.component';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { CommonService } from '../../../services/common.service';
import { Observable, Subscription, Subject, takeUntil, timer } from 'rxjs';
import { MarketplacePageComponent } from 'src/app/customers/marketplace/marketplace.component';
import { SocketService } from 'src/app/socket.service';

@Component({
  selector: 'app-chatbot',
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.scss'],
})
export class ChatBotComponent implements OnInit, OnDestroy, OnChanges {
  /**
   * Socket listeners are found in socket.service.ts
   *
   * currentlyTalkingToId is the id(maybe appUser/biz id) that the user is currently talking to
   * some API have isBiz to distguish the id. some have id/bizId
   *
   * messages of the current chat is in currentChatMessages and will change when user changes chat
   *
   * ---------------------------------------------------------------
   *  1) Sending messages
   * ---------------------------------------------------------------
   *  User 1 -> sendMessage(to, text/imageFile) -> backend
   *  backend -> stores message on db
   *  backend -> new_message(websocket) -> User 2
   *  backend -> sent_message(websocket) -> User 1
   *
   * --------------------------------------------------------------
   *  2) Sending Typing
   * --------------------------------------------------------------
   *  User1 -> sendTyping(to) -> backend
   *  backend -> typing(websocket) -> User2
   *  User2->Add typer id to set and remove after 2 seconds
   *
   *
   *
   */
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.updateVH();
  }

  updateVH() {
    if (!this.sharedService.isBrowser()) {
      return;
    }
    const vh = window.innerHeight;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  @ViewChild('textToSendContainer') private textToSendContainer: ElementRef; //this contains the text that is to be sent
  @ViewChild('scrollContainer') private scrollContainer: ElementRef; //we will use this to automatically scroll the site also check when scrolling upward to fetch older messages
  @ViewChild('buttonChat', { static: false }) buttonChat: ElementRef;
  @ViewChild('contextMenu') contextMenuRef!: ElementRef; //This is used to open context menu in which things like reporting is added
  @ViewChild('fileUpload') fileUpload: ElementRef; //this is invisible and only used to simulate click inorder to select file

  @Output()
  chatModeChange = new EventEmitter<string>(); //we use this to notify if we are in archive or main mode so that we can filter using chatMod
  @Input()
  chatMode = 'Main'; //the current mode which can be Main or Archive
  @Input()
  chatConfig = {
    lockChat: false,
    style: 'old',
    separateChatsByType: false,
    isTypesGroupMode: false,
  };

  @Input()
  forTypeId = null;

  @Input()
  forCategoryId = null;

  @Input()
  allowBackButton = true;

  @Input()
  isAdmin = false;

  @Input()
  showDeleteButton: boolean | null = null; // Optional: if null, defaults to isAdmin

  selectedFile?: File | null = null; //ref to the selected file used to upload
  isCurrentOnline: boolean = false; //whethere the current user is online

  @Input()
  currentlyTalkingToId? = null; //the id of the current user(can be appUser's id or biz's id)
  isCurrentTyping = false; //whether current user is typing
  currentLastSeenTime = 'Last seen at loading ...'; //last seen of currently talking user

  currentProductImage?: string | null = null; //Image of the current product which the conversation is happending about
  currentProductPrice? = null;
  currentProductTitle?: null | string = null; //Name of the current product which the conversation is happending about
  currentProductId?: null | string = null; //Id of the current product, will be used when

  hasCurrentBlockedMe: boolean = false; //NOT USED may have future used

  imageUrl: string = '';

  initLoaded = false;

  chattingNowSub: any = null;
  isLogin = false;
  private readonly guestNameStorageKey = 'chat_guest_name';
  guestName = '';
  guestNameInput = '';
  private deletingMessageIds = new Set<number>();
  openDeleteMenuForMessageId: number | null = null; // Track which message's delete menu is open

  private destroy$ = new Subject<void>();

  public get isGroupChat() {
    return (
      (!!this.forTypeId || !!this.forCategoryId) && !this.currentlyTalkingToId
    );
  }
  public isLeft(message): boolean {
    return (
      (this.isGroupChat &&
        message['from'] != this.localService.getUser()?.id) ||
      (!this.isGroupChat && message['from'] == this.currentlyTalkingToId)
    );
  }
  public isRight(message) {
    return (
      (this.isGroupChat &&
        message['from'] == this.localService.getUser()?.id) ||
      (!this.isGroupChat && message['from'] != this.currentlyTalkingToId)
    );
  }

  public get shouldShowDeleteButton(): boolean {
    return this.showDeleteButton !== null
      ? this.showDeleteButton
      : this.isAdmin;
  }

  /**
   *  position and whether the context menu is visible()
   */
  isContextMenuVisible = false;
  contextMenuX = 0;
  contextMenuY = 0;

  /**
   * messageId the current context is opened on
   */
  currentContextMessageId?: null | string = null;
  isFirstMessageFromChatNow: boolean = false;

  /**
   * The text that is about to be sent
   */
  textToSend = '';

  /**
   * Since uploading an image is usually slower we use this to show uploading... until progess complete or error happens
   */
  uploading? = false;

  @Input()
  currentlyTalkingToName = 'Loading ....'; //The name of the current chat

  /**
   * This array contains the message the current selected chat and will change when user opens another chat
   */
  currentChatMessages: any = [];

  /**
   * All chat lists of the user, changes with every new message since new chat may open or new message may reorder them
   */
  public currentChats: any = [];
  public allChats: any = [];

  //This is used as a threshold to check scroll up and fetch new messages
  private SCROLL_LIMIT = 5;

  //this is used as a boolean to show loading... when older messages are fetched due to scroll
  private isGettingBefore: boolean = false;

  //this is used as a check if the current chat is blocked since if blocked we can't send
  public isCurrentchatBlocked: boolean = false;

  public isSellerAIModeOn: boolean = false;

  private afterMessagesSubscription = null;
  private blockSubs = null;
  private chattingNowSubs = null;
  private chatsSubs = null;
  private currentChatMessagesSusbs = null;

  onFileChanged(e: Event) {
    const input = e.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
    }
  }

  public selectImageForSending() {
    if (this.currentlyTalkingToId === 'ai') {
      console.warn('image selected should not be called on ai');
      return;
    }
    this.fileUpload.nativeElement?.click(); //this field is hidden and is used to simulate
  }

  public dateMarkOf(i): string {
    return this.chatbotService.currentChatDatesMap[i];
  }

  //Formats dates and also chages them to singapore time
  private getFormatedDate(isoString: string) {
    const date = new Date(isoString);

    const singaporeDate = new Date(
      date.toLocaleString('en-US', { timeZone: 'Asia/Singapore' }),
    );

    const hours = singaporeDate.getHours();
    const minutes = singaporeDate.getMinutes();
    const day = singaporeDate.getDate();
    const month = singaporeDate.getMonth() + 1;
    const year = singaporeDate.getFullYear();

    return `${hours}:${minutes
      .toString()
      .padStart(2, '0')} ${day}/${month}/${year}`;
  }

  //this is used to sow Image content of a message in a modal when it's clicked
  public showImage(src: string) {
    this.modalService.dismissAll();
    const ref = this.modalService.open(ImageModalComponent, {
      size: 'sm',
      windowClass: 'image-modal',
    });
    ref.componentInstance.imageSrc = src;
  }

  //unblock current chat
  public unblockCurrrent() {
    if (!this.currentlyTalkingToId) {
      return;
    }
    // console.log('unblocking ', this.currentContextMessageId);
    this.chatbotService.unBlockUser(
      this.currentlyTalkingToId,
      this.isCurrentBiz,
    );
    this.toastr.show('User is unblocked');
  }

  //block current chat
  public blockCurrrent() {
    if (!this.currentlyTalkingToId) {
      return;
    }
    this.chatbotService.blockUser(this.currentlyTalkingToId, this.isCurrentBiz);
    this.toastr.show(
      'User is blocked. You can unblock user in using the popup menu or in advanced settings',
    );
  }

  constructor(
    private toastr: ToastrService,
    private auth: AuthServiceService,
    private chatbotService: ChatbotService,
    private sharedService: SharedService,
    private cdr: ChangeDetectorRef,
    private modalService: NgbModal,
    private renderer: Renderer2,
    private localService: LocalServiceService,
    private commonService: CommonService,
    private socketService: SocketService,
  ) {
    this.imageUrl = environment.ImageUrl;
    this.renderer.listen('document', 'click', (e: Event) => {
      if (
        this.isContextMenuVisible &&
        !this.contextMenuRef.nativeElement.contains(e.target)
      ) {
        this.isContextMenuVisible = false;
      }
      // Close delete menu when clicking outside
      if (this.openDeleteMenuForMessageId !== null) {
        const target = e.target as HTMLElement;
        if (!target.closest('.delete-menu-container')) {
          this.openDeleteMenuForMessageId = null;
        }
      }
    });

    // check if the current is user blocked when blockedUsers changes
    this.blockSubs = this.chatbotService.blockeUsers.subscribe((vals) => {
      //console.log('BLOCKED USER SEGMENT');
      if (
        vals.find((val) => {
          if (
            (!this.isCurrentBiz &&
              val.blocked?.id == this.currentlyTalkingToId) ||
            (this.isCurrentBiz &&
              val.bizBlocked?.id == this.currentlyTalkingToId)
          ) {
            return true;
          }
          return false;
        })
      ) {
        this.isCurrentchatBlocked = true;
      } else {
        this.isCurrentchatBlocked = false;
      }
    });

    //This listens to if current chat is typing
    this.chattingNowSubs = this.chatbotService.chattingNowObservalbe.subscribe(
      (val) => {
        if (this.isSellerAIModeOn) {
          return;
        }
        if (val.has(this.currentlyTalkingToId + '')) {
          this.isCurrentTyping = true;
          this.cdr?.detectChanges();
        } else {
          this.isCurrentTyping = false;
        }
      },
    );

    //listener to if the current chat mode is changed if archive only archive chats are seen the same for main
    this.chatsSubs = this.chatbotService.chats.subscribe((val) => {
      this.allChats = val;
      if (this.chatMode === 'Main') {
        this.currentChats = Array.from(
          this.allChats.filter((chat) => !chat.isArchived),
        );
      } else if (this.chatMode === 'Archive') {
        this.currentChats = Array.from(
          this.allChats.filter((chat) => chat.isArchived),
        );
      }
      // this.cdr.detectChanges();
      this.cdr.markForCheck();
    });

    //this is used to fetch current change messages
    this.currentChatMessagesSusbs =
      this.chatbotService.currentChatMessages.subscribe((val) => {
        if (this.isSellerAIModeOn) {
          return;
        }
        this.currentChatMessages = val;
        // this.cdr.detectChanges();
      });

    ///This is used when only new messages are fetches so that is scrolls, if fetch only is true it makes the new messages seen
    //When a user send message the message and I have opened the chat I don't want to fetch only, I want also to make it seen
    //but when I send a message making it seen is useless as the message is from me
    this.afterMessagesSubscription = this.chatbotService.afterSubject.subscribe(
      (fetchOnly) => {
        if (this.isSellerAIModeOn) {
          return; //this is because ai is different from normal messages
        }
        this.scrollChatBottom();
        if (!fetchOnly) {
          // console.log(`Making messages of ${this.currentlyTalkingToId} seen`);
          this.timeout(600).then(() =>
            this.chatbotService.makeChatMessagesSeen(this.currentlyTalkingToId),
          );
        }
      },
    );
  }

  private timeout(ms): Promise<void> {
    return new Promise((res) => {
      setTimeout(res, ms);
    });
  }

  //Adde the current chat to archives
  addChatToArchive() {
    if (!this.currentlyTalkingToId) {
      return;
    }
    this.auth
      .add_chat_to_archives(this.currentlyTalkingToId, this.isCurrentBiz)
      .subscribe(() => {
        this.chatbotService.getAllChats(this.chatConfig.separateChatsByType);
        this.chatbotService.getTotalUnreadMessagesCount();
        this.toastr.show('Chat added to Arhives');

        this.chatModeChange.emit('Archive');
      });
  }

  //removes current chat from archives
  removeChatFromArchive() {
    if (!this.currentlyTalkingToId) {
      return;
    }
    this.auth
      .remove_chat_from_archives(this.currentlyTalkingToId, this.isCurrentBiz)
      .subscribe(() => {
        this.chatbotService.getAllChats(this.chatConfig.separateChatsByType);
        this.chatbotService.getTotalUnreadMessagesCount();
        this.toastr.show('Chat removed from Arhives');

        this.chatModeChange.emit('Main');
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.chatMode) {
      if (changes.chatMode.currentValue === 'Main') {
        this.currentChats = Array.from(
          this.allChats.filter((chat) => !chat.isArchived),
        );
      } else if (changes.chatMode.currentValue === 'Archive') {
        this.currentChats = Array.from(
          this.allChats.filter((chat) => chat.isArchived),
        );
      }
    }
    if (changes.chatConfig) {
      if (
        changes.chatConfig.currentValue?.separateChatsByType !=
        changes.chatConfig.previousValue?.separateChatsByType
      ) {
        this.chatbotService.getAllChats(this.chatConfig.separateChatsByType);
      }
      this.cdr.detectChanges(); //may be not needed
    }
    if (changes.currentlyTalkingToId) {
      //setChat(this.currentlyTalkingToId)
      this.setChat(this.currentlyTalkingToId);
      //this.startRefreshChatData();

      // this.sharedService.chatNowSubject.next({ chatingNow:  this.currentlyTalkingToId, menu: 'chat', })
    }
    if (changes.forTypeId || changes.forCategoryId) {
      this.resetChat();
      // this.setChat(this.currentlyTalkingToId)
    }
  }

  private resetChat() {
    this.socketService.init();
    this.chatbotService.forTypeId = this.forTypeId;
    this.chatbotService.forCategoryId = this.forCategoryId;
    this.clearAllMessages();
    this.setChat(this.currentlyTalkingToId);
  }
  //get hour and minute only of a string after making it to singapore time
  getHourAndMinute(isoString: string) {
    const date = new Date(isoString);

    const singaporeDate = new Date(
      date.toLocaleString('en-US', { timeZone: 'Asia/Singapore' }),
    );

    const hours = singaporeDate.getHours();
    const minutes = singaporeDate.getMinutes();

    return `${hours}:${minutes.toString().padStart(2, '0')}`;
  }

  ngOnDestroy(): void {
    this.chattingNowSub?.unsubscribe();
    this.afterMessagesSubscription?.unsubscribe();
    this.blockSubs?.unsubscribe();
    this.chattingNowSubs?.unsubscribe();
    this.chatsSubs?.unsubscribe();
    this.currentChatMessagesSusbs?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * used to open custom context menu on messages
   * message bubble contain a custom attribute called messageId so that we can know which message the context menu is about
   */

  rightClickMessageHandler(event: MouseEvent) {
    const target = event.currentTarget as HTMLElement;

    const validContext = target.getAttribute('validContext');
    if (validContext == 'false') {
      return;
    }

    event.preventDefault();
    const messageId: string = target.getAttribute('messageId')!;

    this.contextMenuX = event.clientX;
    this.contextMenuY = event.clientY;
    this.isContextMenuVisible = true;
    this.currentContextMessageId = messageId;
  }

  //used to open a report form on a message
  openReportForm() {
    this.isContextMenuVisible = false;
    const ref = this.modalService.open(ReportChatMessageModalComponent, {
      size: 'sm',
      windowClass: 'reports-modal',
    });
    ref.componentInstance.messageToBeReportedId = this.currentContextMessageId;
    ref.componentInstance.personToBeReportedOn = this.currentlyTalkingToId;
  }
  private listenToLoginStatus() {
    this.localService
      .getUserDetailsObserver()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        this.isLogin = !!user;
        if (!this.isLogin) {
          //this.hydrateGuestNameFromStorage();
          this.getTemporaryNameFromIp();
        } else {
          this.guestNameInput = '';
        }
      });
  }

  ngOnInit(): void {
    this.updateVH();
    // this.setChat(this.currentlyTalkingToId)
    this.resetChat();

    //this.hydrateGuestNameFromStorage();
    this.getTemporaryNameFromIp();

    this.listenToLoginStatus();

    return;

    //this accepts parrams from triggerChatNow and sets everything up
    const chattingNowSubscriber = (val) => {
      if (!val) {
        return;
      }
      if (!val.chatingNow || !val.chatTitle) {
        // console.log('Chat trigger value missing: ', val);
        return;
      }

      if (this && this.setChat) {
        if (val.isFirstMessageFromChatNow) {
          this.isFirstMessageFromChatNow = true;
        }
        this.setChat(
          val.chatingNow,
          val.chatTitle,
          val.lastSeenTime,
          val.productName,
          val.productImage,
          val.productId,
          val.isBiz,
        );
      }
    };

    //needs the current value
    chattingNowSubscriber(this.sharedService.chatNowSubject.value);
    this.chattingNowSub = this.sharedService.chatNowSubject.subscribe(
      chattingNowSubscriber,
    );
  }

  /**
   * this listens to the key up event on the text input of chat messages
   */
  chatKeyListener(event) {
    const { key } = event;

    if (key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.sendMessage(); //send message if enter is clicked and shiftKey is not pressed
    } else if ((key === 'Enter' && event.shiftKey) || key === 'Backspace') {
      //if shift key is pressed with enter make new line and resize...the same for backspace

      this.textToSendContainer.nativeElement.style.height = 'auto';
      this.textToSendContainer.nativeElement.style.height =
        this.textToSendContainer.nativeElement.scrollHeight + 'px';
      return;
    } else if (
      this.currentlyTalkingToId &&
      this.currentlyTalkingToId !== 'ai' &&
      !this.isSellerAIModeOn
    ) {
      //if the user just types just send typing request to the current user
      this.auth
        .send_typing_message(this.currentlyTalkingToId, this.isCurrentBiz)
        ?.subscribe({
          error: console.error,
        });
      if (this.textToSend?.length % 20 == 0) {
        this.textToSendContainer.nativeElement.style.height = 'auto';
        this.textToSendContainer.nativeElement.style.height =
          this.textToSendContainer.nativeElement.scrollHeight + 'px';
      }
    }
  }

  //the back arrow uses this sets everything down also clears the interval that gets user status in every 5 mins
  goBacktoChatList() {
    this.currentlyTalkingToId = null;
    clearInterval(this.getChatDataInterval);
    this.getChatDataInterval = null;
    this.isGettingBefore = false;
    this.clearAllInfosAndClearSubs();
  }
  getDateOnly(isoString) {
    const date = new Date(isoString);

    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();

    // Format minutes to always show two digits
    return `${day}/${month}/${year}`;
  }

  //This functions toggles the ai mode for sellers
  //AI will answer questions on behalf of the seller
  public async toggleAIChatMode() {
    this.isSellerAIModeOn = !this.isSellerAIModeOn;

    const timeOut = (time) => {
      return new Promise((res, rej) => {
        setTimeout(res, time);
      });
    };

    await timeOut(500);
    //since other fetching chat data might interfere

    this.clearAllMessages();
    if (this.isSellerAIModeOn) {
      this.addNewTextMessageToCurrentChats(
        'Hey 👋, AI will now answer chat messages on behalf of the seller',
        {
          from: this.currentlyTalkingToId,
        },
      );
    } else {
      //we reset the old chat here set chat will fetch messages again
      this.setChat(
        this.currentlyTalkingToId,
        'Loading...', //just to singal to the user
        this.currentLastSeenTime,
        this.currentProductTitle,
        this.currentProductImage,
        this.currentProductId,
        this.isCurrentBiz,
      );
    }
  }

  //Please only use this for AI part only
  //used to store messages here on the browser but not on db so needs to update chat message
  private addNewTextMessageToCurrentChats(
    textContent: string,
    { from = null, to = null, sendTime = new Date().toISOString() },
  ) {
    if (!textContent) {
      // console.error('Error invalid param');
    }
    if (this.currentlyTalkingToId != from && this.currentlyTalkingToId != to) {
      return;
    }
    this.currentChatMessages.push({ textContent, from, to, sendTime });
    this.currentChatMessages = [...this.currentChatMessages];
  }

  //send the message to the ai model instead of the user and injects the reponse back to the messages array
  private sendMessageToAI(contextUserId) {
    if (!this.textToSend) {
      return;
    }
    this.isCurrentTyping = true;
    this.addNewTextMessageToCurrentChats(this.textToSend, {
      to: contextUserId,
    });
    let subs: Observable<any>;
    if (contextUserId === 'ai' || !this.currentProductId) {
      subs = this.auth.chatRequestMessage({
        user_message: this.textToSend,
        user_id:
          contextUserId === 'ai'
            ? this.localService?.getUser()?.id?.toString()
            : contextUserId.toString(),
      });
    } else {
      subs = this.auth.chatSellerRequest({
        user_id: this.localService?.getUser()?.id?.toString(),
        seller_id: contextUserId?.toString(),
        product_id: this.currentProductId?.toString(),
        query: this.textToSend,
        product_details:
          this.currentProductId === null
            ? 'No Product'
            : (this.currentProductTitle ?? '') +
              ' ' +
              (this.lastMesssageAboutProduct?.description ?? ''),
      });
    }

    subs.subscribe({
      next: (data) => {
        this.isCurrentTyping = false;

        this.addNewTextMessageToCurrentChats(data.body.response_message, {
          from: contextUserId,
        });
        this.scrollChatBottom();
      },
      error: (err) => {
        // console.error(err);
        this.isCurrentTyping = false;
        this.toastr.error(
          'Something went wrong while sending the message to ai',
        );
      },
    });
    this.textToSend = '';
    this.scrollChatBottom();
  }
  /**
   *
   * sends the message to the currentlyTalkingToId
   * 1) checks if the message the firstMessage and is from product...if so will send notification to the other user that chat is started(doesn't work for biz)
   * 2) sends the message and checks for error
   */
  sendMessage() {
    if (this.currentlyTalkingToId === 'ai' && this.textToSend) {
      this.sendMessageToAI('ai');
      return;
    }
    //the code below will send the message to ai endpoint instead of the user and get response from ai
    if (this.currentlyTalkingToId && this.isSellerAIModeOn && this.textToSend) {
      this.sendMessageToAI(this.currentlyTalkingToId);
      return;
    }
    if (
      this.isFirstMessageFromChatNow &&
      this.currentlyTalkingToId &&
      !this.isCurrentBiz
    ) {
      this.auth
        .addChatNotification(this.currentlyTalkingToId, 'chat-notif', {
          textSent: this.textToSend,
          productName: this.currentProductTitle,
          isMessagePhoto: !!this.selectedFile,
        })
        .subscribe({
          next: () => {},
        });
    }
    this.isFirstMessageFromChatNow = false;
    // console.log('sending with product id = ', this.currentProductId);
    if (!this.textToSend?.trim() && !this.selectedFile) {
      return;
    }

    if (!this.isLogin && !this.guestName?.trim()) {
      this.toastr.warning('Please enter your name before sending a message.');
      return;
    }

    const ipAddress = this.commonService.clientIp || '';

    if (this.selectedFile) {
      this.uploading = true;
    }
    const args = {
      to: this.currentlyTalkingToId,
      textContent: this.textToSend,
      imageContent: this.selectedFile,
      aboutProductId: this.currentProductId,
      forTypeId: this.forTypeId,
      forCategoryId: this.forCategoryId,
      fromName: this.isLogin ? undefined : this.guestName,
      tempName: this.isLogin ? undefined : this.guestName,
      ipAddress,
    };
    this.chatbotService.sendMessage(args).subscribe({
      next: (resp) => {
        if (resp.type === HttpEventType.Response) {
          this.toastr.show('Message sent!');
          //this.chatbotService.getAllChats();
          this.uploading = false;
        }
      },

      error: (err) => {
        this.toastr.show(
          'Unable to send Message: ' + (err?.error?.message ?? ''),
        );
        // console.error(err);
        this.uploading = false;
      },
    });
    this.textToSendContainer.nativeElement.style.height = '2.5rem';
    this.textToSend = '';
    this.removeSelectedFiles();
  }

  public removeSelectedFiles() {
    this.selectedFile = null;
    this.fileUpload.nativeElement.value = '';
  }

  public getChatDataInterval?: any = null; //interval(5 minutes) to check if the current user is online or get their last seen. also gets changes if user changes their name of profile picture/
  public isCurrentBiz = false; //true if the current chat is a biz chat

  public lastMesssageAboutProduct?: any = null;
  public whatsAppNumber?: string | null = null;
  public openChatsWhatsApp() {
    if (!this.whatsAppNumber) {
      // console.error('Open whats app called on empty whats app number');
      return;
    }
    window.open(`https://wa.me/${this.whatsAppNumber}`, '_blank');
    this.auth
      .addChatNotification(this.currentlyTalkingToId, 'whatsapp')
      .subscribe({
        next: () => {},
      });
  }

  private clearAllMessages() {
    this.currentChatMessages = [];
    this.chatbotService.currentChatMessages.next([]);
  }

  private clearAllInfosAndClearSubs() {
    this.isCurrentOnline = true;
    this.isCurrentBiz = false;

    this.clearAllMessages();
    this.currentProductImage = null;
    this.currentProductPrice = null;
    this.currentProductTitle = null;
    this.selectedFile = null;

    if (this.getChatDataInterval) {
      clearInterval(this.getChatDataInterval);
    }
    this.getChatDataInterval = null;
    this.isCurrentTyping = false;
    this.isCurrentchatBlocked = false;
    this.isGettingBefore = false;
    this.uploading = false;
    this.textToSend = '';

    this.currentProductId = null;
    this.currentlyTalkingToId = null;
    this.whatsAppNumber = null;

    this.currentLastSeenTime = 'Loading...';
    this.currentlyTalkingToName = 'Loading..';

    // this.chattingNowSub?.unsubscribe();
    // this.afterMessagesSubscription?.unsubscribe();
    // this.blockSubs?.unsubscribe();
    // this.chattingNowSubs?.unsubscribe();
    // this.chatsSubs?.unsubscribe();
    // this.currentChatMessagesSusbs?.unsubscribe();
  }

  private setupAIChat() {
    this.clearAllInfosAndClearSubs();
    this.currentlyTalkingToId = 'ai';
    this.currentlyTalkingToName = '🤖 AI Chat';
    this.isCurrentOnline = true;
    this.isCurrentBiz = false;
  }

  public aiChatAllowed = false;

  //is main chat allow to be seen in the settings of the user
  public get showMainAI(): boolean {
    return this.chatbotService.showMainAI;
  }

  private startRefreshChatData() {
    if (!this.sharedService.isBrowser() || !this.currentlyTalkingToId) {
      return;
    }
    const getChatDataFunc = () => {
      if (!this.currentlyTalkingToId && this.getChatDataInterval) {
        clearInterval(this.getChatDataInterval);
        this.getChatDataInterval = null;
        return;
      }

      this.auth
        .get_chat_data(this.currentlyTalkingToId, this.isCurrentBiz)
        .subscribe((data: any) => {
          this.currentlyTalkingToName = data.chatData.profileCharacterName;
          this.aiChatAllowed = data.chatData.allowBotChat;
          if (this.isCurrentBiz) {
            this.isCurrentOnline = true;
            return;
          }
          this.currentLastSeenTime =
            'last Seen at ' + this.getFormatedDate(data.chatData.lastSeenTime);
          if (data.isOnline) {
            this.isCurrentOnline = true;
          } else {
            this.isCurrentOnline = false;
          }
          this.whatsAppNumber = data.whatsAppNumber;
          // console.log('Whatsapp Number is ', this.whatsAppNumber);
        });
    };

    getChatDataFunc();
    if (this.getChatDataInterval) {
      clearInterval(this.getChatDataInterval);
      this.getChatDataInterval = null;
    }
    this.getChatDataInterval = setInterval(getChatDataFunc, 5 * 60 * 1000); //refresh every 5 mins
  }

  /**
   * This runs when chat is set.
   */
  public setChat(
    chatId,
    title = null,
    lastSeen = null,
    productName = null,
    productImage = null,
    productId = null,
    isBiz = false,
    skipSetId = false,
  ) {
    // this.clearAllInfosAndClearSubs();
    if (chatId == 'ai') {
      this.setupAIChat();
      return;
    }
    this.isCurrentBiz = isBiz;
    this.isSellerAIModeOn = false;
    this.clearAllMessages();

    //Scroll to the bottom and set the current chat Id and isBiz in the service
    this.chatbotService.setCurrentChat(chatId, isBiz).then(() => {
      setTimeout(() => {
        this.scrollChatBottom();
        setTimeout(() => (this.initLoaded = true));
      }, 1000);
    });
    this.whatsAppNumber = null;
    //This function fetchs the data of the current chat like name lastseen/online..
    //also it's called in every 5 minutes to upate information

    if (lastSeen) {
      this.currentLastSeenTime = lastSeen; //if last seen
    } else {
      this.currentLastSeenTime =
        this.chatbotService.getChatLastSeenForId(chatId) ?? ''; //if the current last seen is store use it until network request
    }
    if (
      this.chatbotService.blockeUsers.value.find((block) => {
        return (
          (this.isCurrentBiz && block?.bizBlocked?.id == chatId) ||
          (!this.isCurrentBiz && block?.blocked?.id == chatId)
        );
      })
    ) {
      this.isCurrentchatBlocked = true;
    } else {
      this.isCurrentchatBlocked = false;
    }

    const previousChatProductData =
      this.chatbotService.getProductDataForChat(chatId);
    if (previousChatProductData) {
      if (this.isCurrentBiz) {
      } else {
        this.currentProductImage =
          this.imageUrl +
          previousChatProductData.memberShopProductsImages[0].image;
        this.currentProductTitle = previousChatProductData.name;
        this.currentProductId = previousChatProductData.id;
        this.lastMesssageAboutProduct = previousChatProductData;
      }
    }

    //This is used to show the name and image of the product in which the chat is about
    if (productImage && productName) {
      this.currentProductImage = environment.ImageUrl + productImage;

      this.currentProductTitle = productName;
      this.currentProductId = productId;
    } else if (!previousChatProductData) {
      this.currentProductImage = null;
      this.currentProductTitle = null;
      this.currentProductId = null;
    }

    if (!skipSetId) {
      this.currentlyTalkingToId = chatId;
    }

    this.startRefreshChatData();

    if (!title && !this.currentlyTalkingToName) {
      this.currentlyTalkingToName = 'Loading...';
    } else if (!this.currentlyTalkingToName) {
      this.currentlyTalkingToName = title;
    }

    // this.chatbotService
    //   .makeChatMessagesSeen(chatId)
    //   ?.then(this.scrollChatBottom);
  }

  scrollChatBottom() {
    if (this) {
      this.cdr?.detectChanges();
    }

    setTimeout(() => {
      if (this && this.scrollContainer?.nativeElement) {
        this.scrollContainer.nativeElement.scrollTop =
          this.scrollContainer.nativeElement.scrollHeight;
      } else {
      }
    }, 0); //just to be called latter in the event loop
  }

  /**
   *
   * Listener for scrolling event in the chat, fetchs before messages also marks isGettingBefore so loadin ... can appear
   * also waits 1 sec because not to flood with every returns if already getting before not to flood the backend
   */
  public async onMessageScroll() {
    if (this.isSellerAIModeOn || this.currentlyTalkingToId == 'ai') {
      return; //if ai mode is one not need to get old messages
    }

    this.isContextMenuVisible = false;
    if (
      this.isGettingBefore ||
      (!this.currentlyTalkingToId && !this.isGroupChat)
    ) {
      //console.log('already getting before!');
      return;
    }
    this.isGettingBefore = true;
    const currentScrollTop = this.scrollContainer?.nativeElement.scrollTop;

    const timeOut = (x) =>
      new Promise((res, rej) => {
        setTimeout(res, x);
      });

    if (
      currentScrollTop < this.SCROLL_LIMIT &&
      this.scrollContainer.nativeElement.scrollHeight > this.SCROLL_LIMIT
    ) {
      try {
      //  console.log('fetching');
        // console.log('Scroll up detected ');
        await timeOut(1000);
        await this.chatbotService.getBeforeMesssage();
        this.scrollContainer.nativeElement.scrollTop += 35;
      } catch (e) {
        console.warn(e);
      }
    } else {
    //  console.log('not fetching');
    }

    this.isGettingBefore = false;
  }

  public textLink(text: string) {
    let response = text;
    for (let i = 0; i < response.split('[').length; i++) {
      const placeholder = this.localService.getStringBetween(
        response,
        '[placeholder]',
        '[placeholder]',
      );
      const link = this.localService.getStringBetween(
        response,
        '[link]',
        '[link]',
      );

      response = response.replaceAll(
        `[placeholder]${placeholder}[placeholder][link]${link}[link]`,
        `
        <a href="${link}" id="link_chat_${link}" class="text-primary" target="_blank">${placeholder}</a>
      `,
      );
    }
    return response;
  }

  public handleClickLink(event: MouseEvent) {
    event.preventDefault();
    const target = event.target as HTMLAnchorElement;

    if (target.tagName === 'A') {
      const id = target.id; // Check the target id
      if (target.href.includes('product=')) {
        const payload = {
          id: target.href.split('-').pop(),
          enableMemberShop: !target.href.includes('-biz-'),
        };
        //console.log(target, 'TARGETT', target?.href);
        this.viewProductDetails(payload);
      }
    }
  }

  public viewProductDetails(product: any): void {
    this.sharedService.triggerOpenProductDetail(product);
  }

  private getTemporaryNameFromIp() {
    const ipAddress = this.commonService.clientIp || '';
    this.auth.getTemporaryName(ipAddress).subscribe({
      next: (data) => {
        this.guestName = data.body.name;
      },
    });
  }

  private hydrateGuestNameFromStorage(): void {
    if (!this.sharedService.isBrowser()) {
      return;
    }
    const storedName = localStorage.getItem(this.guestNameStorageKey);
    this.guestName = storedName?.trim() ?? '';
    this.guestNameInput = this.guestName;
  }

  confirmGuestName(): void {
    const trimmed = (this.guestNameInput || '').trim();
    if (!trimmed) {
      return;
    }
    this.guestName = trimmed;
    this.guestNameInput = trimmed;
    if (this.sharedService.isBrowser()) {
      localStorage.setItem(this.guestNameStorageKey, trimmed);
    }
  }

  toggleDeleteMenu(message: any, event?: Event): void {
    event?.stopPropagation();
    event?.preventDefault();
    if (!message?.id) {
      return;
    }
    const messageId = Number(message.id);
    if (Number.isNaN(messageId)) {
      return;
    }

    // Toggle the menu - if already open for this message, close it; otherwise open it
    if (this.openDeleteMenuForMessageId === messageId) {
      this.openDeleteMenuForMessageId = null;
    } else {
      this.openDeleteMenuForMessageId = messageId;
    }
  }

  isDeleteMenuOpen(message: any): boolean {
    if (!message?.id) {
      return false;
    }
    return this.openDeleteMenuForMessageId === Number(message.id);
  }

  confirmDeleteMessage(message: any, event?: Event): void {
    event?.stopPropagation();
    event?.preventDefault();
    this.openDeleteMenuForMessageId = null; // Close menu

    if (!this.shouldShowDeleteButton || !message?.id) {
      return;
    }
    const messageId = Number(message.id);
    if (Number.isNaN(messageId) || this.deletingMessageIds.has(messageId)) {
      return;
    }

    if (
      this.sharedService.isBrowser() &&
      !window.confirm('Delete this message?')
    ) {
      this.deletingMessageIds.delete(messageId);
      return;
    }

    this.deletingMessageIds.add(messageId);
    this.chatbotService.deleteMessage(messageId).subscribe({
      next: () => {
        this.chatbotService.removeMessageFromCurrent(messageId);
        this.currentChatMessages = this.currentChatMessages.filter(
          (msg) => msg?.id !== messageId,
        );
        this.toastr.success('Message deleted');
      },
      error: (err) => {
        this.toastr.error(err?.error?.error ?? 'Unable to delete message');
        this.deletingMessageIds.delete(messageId);
      },
      complete: () => {
        this.deletingMessageIds.delete(messageId);
      },
    });
  }

  banUserFromMessage(message: any, event?: Event): void {
    event?.stopPropagation();
    event?.preventDefault();
    this.openDeleteMenuForMessageId = null; // Close menu

    if (!message?.from && !this.commonService.clientIp) {
      this.toastr.error('Unable to identify user');
      return;
    }

    const userId = message.from;
    const userName = message.fromName || 'User';

    if (
      this.sharedService.isBrowser() &&
      !window.confirm(
        `Ban ${userName}? This will ban the user from the chat system.`,
      )
    ) {
      return;
    }

    // Use chatUserBanned API to ban user
    if (this.isAdmin) {
      // Use ban_chat_user API which uses chatUserBanned table
      this.auth.ban_chat_user(userId, this.commonService.clientIp).subscribe({
        next: (response: any) => {
          if (response.success) {
            this.toastr.success(`User ${userName} has been banned from chat`);
            // Also block in chat for immediate effect
            this.chatbotService.blockUser(userId, this.isCurrentBiz);
          } else {
            this.toastr.warning(response.message || 'User ban status updated');
          }
        },
        error: (err) => {
          this.toastr.error(err?.error?.error ?? 'Unable to ban user');
        },
      });
    } else {
      // Non-admin users can only block, not ban
      this.chatbotService.blockUser(userId, this.isCurrentBiz);
      this.toastr.success(`User ${userName} has been blocked`);
    }
  }

  deleteMessage(message: any, event?: Event): void {
    // Keep old method for backward compatibility, but use new method
    this.confirmDeleteMessage(message, event);
  }
}
